import Vue from 'vue'
import { URL_ORGANIZATION_REQUESTS } from '@/constants/urls.js'
import { ORG_REQUEST_STATUSES } from '@/constants/business.js'
import { ORGANIZATION_REQUESTS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [ORGANIZATION_REQUESTS.STATE.REQUESTS]: {
    [ORG_REQUEST_STATUSES.CREATED]: null,
    [ORG_REQUEST_STATUSES.INPROCESS]: null,
    [ORG_REQUEST_STATUSES.APPROVED]: null,
    [ORG_REQUEST_STATUSES.REJECTED]: null
  },
  [ORGANIZATION_REQUESTS.STATE.CURRENT_REQUEST]: null
}

const actions = {
  async [ORGANIZATION_REQUESTS.ACTIONS.GET_ORGANIZATION_REGISTRATION_REQUESTS] ({ dispatch, commit }, params) {
    const status = params.status
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_REQUESTS}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_REQUESTS.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUESTS, {
      requests: resp.data,
      status
    })
  },
  async [ORGANIZATION_REQUESTS.ACTIONS.GET_ORGANIZATION_REQUEST_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_REQUESTS}/${model.organizationId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(ORGANIZATION_REQUESTS.MUTATIONS.GET_ORGANIZATION_REQUEST_INFO, resp.data)
  },
  async [ORGANIZATION_REQUESTS.ACTIONS.PROCESS_ORGANIZATION_REGISTRATION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION_REQUESTS}/${model.organizationId}/process`,
      model: model.model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [ORGANIZATION_REQUESTS.ACTIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUESTS] ({ commit }, status) {
    commit(ORGANIZATION_REQUESTS.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUESTS, status)
  },
  async [ORGANIZATION_REQUESTS.ACTIONS.CLEAR_ORGANIZATION_REQUEST_INFO] ({ commit }) {
    commit(ORGANIZATION_REQUESTS.MUTATIONS.CLEAR_ORGANIZATION_REQUEST_INFO)
  }
}

const mutations = {
  [ORGANIZATION_REQUESTS.MUTATIONS.GET_ORGANIZATION_REGISTRATION_REQUESTS] (state, model) {
    state[ORGANIZATION_REQUESTS.STATE.REQUESTS][model.status] = model.requests
  },
  [ORGANIZATION_REQUESTS.MUTATIONS.GET_ORGANIZATION_REQUEST_INFO] (state, request) {
    state[ORGANIZATION_REQUESTS.STATE.CURRENT_REQUEST] = request
  },
  [ORGANIZATION_REQUESTS.MUTATIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUESTS] (state, status) {
    state[ORGANIZATION_REQUESTS.STATE.REQUESTS][status] = null
  },
  [ORGANIZATION_REQUESTS.MUTATIONS.CLEAR_ORGANIZATION_REQUEST_INFO] (state) {
    state[ORGANIZATION_REQUESTS.STATE.CURRENT_REQUEST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
